module.exports = __webpack_public_path__ + "assets/img/warrior-name-2090a65d.png";